<template>
    <div class="mainbox">
        <div class="school_detail">
            <div class="line"></div>
            <div class="s_til">招生简章</div>
        </div>
        <div class="detail">
            <div class="detail_list">
                <div v-for="(item, index) in lists" :key="index" class="detail_item">
                    <div class="item_left">
                        <div class="i_img">
                            <img :src="item.cover" alt="">
                        </div>
                        <div v-if="projectType == 0" class="item_detail">
                            <div class="i_til">{{ item.name }}</div>
                            <div class="i_tils elp"> <span>招生计划：</span>{{ item.enrollPlan }} 人</div>
                            <div class="i_tils elp"> <span>学习形式：</span>{{ item.studyType }}</div>
                            <div class="i_tils elp"> <span>招生专业：</span>{{ item.majorNameList }}</div>
                            <div class="i_tils ">
                                <span>简章简介：</span>
                                <div style="max-width: 600px;" v-html="ImgSizeLimit(item.detial)" class="twoEllipsis">
                                </div>
                            </div>
                        </div>
                        <div v-if="projectType == 5" class="item_detail">
                            <div class="i_til">{{ item.name }}</div>
                            <div class="i_tils elp"> <span>招生对象：</span>{{ item.enrollObject }}</div>
                            <div class="i_tils elp"> <span>学 制：</span>{{ item.academic }} 年</div>
                            <div class="i_tils elp"> <span>招生人数：</span>{{ item.enrollPlan }}</div>
                            <div class="i_tils elp"> <span>留学国家：</span>{{ item.countryNameList }}</div>
                        </div>
                        <div style="display: flex;flex-wrap: wrap;align-items: flex-start;" v-if="projectType == 1"
                            class="item_detail">
                            <div style="width: 100%;" class="i_til">{{ item.name }}</div>
                            <div style="width: 40%;" class="i_tils elp"> <span>招生类别：</span>{{ item.projectCategoryName
                                }}</div>
                            <div style="width: 40%;" class="i_tils elp"> <span>招生专业：</span>{{ item.majorName }}</div>
                            <div style="width: 40%;" class="i_tils elp"> <span>学习时长：</span>{{ item.academic }}</div>
                            <div style="width: 40%;" class="i_tils elp"> <span>所获证书：</span>{{ item.certificate }}</div>
                        </div>
                    </div>
                    <div class="item_right">
                        <div class="line"></div>
                        <div @click="goNext(`/gxGathers/school/enrollmentGuide?enrollId=${item.id}&id=${id}`)"
                            class="i_btn">查看简章
                        </div>
                    </div>
                </div>
                <el-empty style="margin: 0 auto;" v-if="!lists || lists.length == 0" description="暂无数据"></el-empty>

                <el-pagination background style="display: flex;justify-content: center;" :page-count="4"
                    class="pagination partner-pagination" :current-page="pageNum" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total"
                    @current-change="handleCurrentChange" @size-change="handleSizeChange"
                    :page-sizes="[4, 20, 50, 100]" />

            </div>
        </div>
    </div>
</template>

<script>
import { Know } from "@/api/know";
let know = new Know();
import { getDomain } from "@/api/cookies";
export default {
    components: {},
    props: {
        id: ''
    },
    data() {
        return {
            projectType: '',
            pageSize: 4,
            pageNum: 1,
            total: 0,
            lists: []
        };
    },
    created() {
        this.projectType = localStorage.getItem('projectType');

        this.selectSchoolBriefsPcList()
    },
    mounted() {

    },
    methods: {
        selectSchoolBriefsPcList() {
            if (this.projectType == 0) {
                know.selectSchoolBriefsPcList({
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    projectType: this.projectType,
                    schoolId: this.id,
                })
                    .then((res) => {
                        this.lists = res.rows
                        this.total = res.total
                    });
            } else if (this.projectType == 5) {
                know.selectBriefsPcAbroadPage({
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    projectType: this.projectType,
                    schoolId: this.id,
                })
                    .then((res) => {
                        this.lists = res.rows
                        this.total = res.total
                    });
            }
            else if (this.projectType == 1) {
                know.selectBriefsPcGraduatePage({
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    projectType: this.projectType,
                    schoolId: this.id,
                })
                    .then((res) => {
                        this.lists = res.rows
                        this.total = res.total
                    });
            }

        },
        handleSizeChange(val) {
            this.pageNum = 1
            this.pageSize = val
            this.selectSchoolBriefsPcList()
        },
        handleCurrentChange(val) {
            this.pageNum = val
            this.selectSchoolBriefsPcList()
        },
    },
};
</script>

<style lang="less" scoped>
.mainbox {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
    background: #fff;
    padding-bottom: 10px;
    padding-top: 0;


    .school_detail {
        position: relative;
        width: 1200px;
        border-radius: 3px 3px 3px 3px;
        padding: 20px;

        .line {
            position: absolute;
            width: 6px;
            height: 24px;
            background: #1061FF;
            border-radius: 0px 4px 4px 0px;
            left: 0;
            top: 23px;
        }

        .s_til {
            font-family: MicrosoftYaHei-Bold, MicrosoftYaHei-Bold;
            font-weight: bold;
            font-size: 24px;
            color: #444444;
        }

    }

    .detail {
        display: flex;
        padding: 20px;
        padding-bottom: 0;
        padding-top: 0;

        .detail_list {
            width: 100%;

            .detail_item {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 20px;

                .item_left {
                    display: flex;

                    .i_img {
                        flex-shrink: 0;
                        width: 232px;
                        height: 200px;
                    }

                    .item_detail {
                        margin-left: 20px;

                        .i_til {

                            font-family: MicrosoftYaHei-Bold, MicrosoftYaHei-Bold;
                            font-weight: normal;
                            font-size: 18px;
                            color: #333333;
                            font-weight: bold;
                            margin-bottom: 10px;

                        }

                        .i_tils {
                            font-family: MicrosoftYaHei, MicrosoftYaHei;
                            font-weight: normal;
                            font-size: 14px;
                            color: #555555;
                            margin-top: 10px;
                            display: flex;

                            span {
                                display: block;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 14px;
                                color: #555555;
                                flex-shrink: 0;
                            }
                        }
                    }
                }

                .item_right {
                    display: flex;
                    align-items: center;
                    flex-shrink: 0;


                    .line {
                        width: 0px;
                        height: 90px;
                        border: 1px solid #EEEEEE;
                    }

                    .i_btn {
                        width: 138px;
                        height: 40px;
                        background: #1061FF;
                        border-radius: 20px 20px 20px 20px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-family: MicrosoftYaHei, MicrosoftYaHei;
                        font-weight: normal;
                        font-size: 14px;
                        color: #FFFFFF;
                        cursor: pointer;
                        margin-left: 36px;

                        &:hover {
                            background: #3D6CC8;
                        }
                    }
                }
            }
        }
    }


}

img {
    display: block;
    width: 100%;
    height: 100%;
}
</style>